/*import Logo from "../Assets/cngrupocolor.png";*/
import React from "react";
/*import { BrowserRouter, Link, Route, Routes } from "react-router-dom";*/
import { Contactocomponente } from "../Components/Contactocomponente";
import { useTranslation } from "react-i18next";
import NAVBAR from "./NavBarNueva";
import NAVBARMOBILE from "./NavBarMobile";
import "./Contacto.css";

const Contacto = () => {
  // eslint-disable-next-line no-unused-vars
  const [t, i18next] = useTranslation("global");

  return (
    <div className="home-container-contacto">
      <div className="home-container-contacto-hero">
        <div className="BarraEscritorio">
          <NAVBAR></NAVBAR>
        </div>
        <div className="BarraMobile">
          <NAVBARMOBILE></NAVBARMOBILE>
        </div>
        <div className="txt-redesContacto">
          <div className="txt-container-empresaContacto">
            <div className="linea-titulo-contacto">
              <div className="badge-contacto">
                <p className="badge-contacto-texto">{t("li.CONTACT")}</p>
              </div>
            </div>
            <h2 className={i18next.language === "es" ? "Contacto-title" : "Contacto-titleEN"}>
              {t("li.contact-txt")}
            </h2>
          </div>
        </div>
      </div>
      
      <div className="contenido-principal-contacto">
        <div className="contenedores-contacto">
          <div className="contenedor-izquierdo-contacto">
            <h2 className="titulo-Contacto">
              {t("txtContactoPagina.txt1")}<br></br>{t("txtContactoPagina.txt2")}
            </h2>
            <p className="p-contacto1">
                {t("txtContactoPagina.txt3")}
            </p>
            <Contactocomponente showMap={false}></Contactocomponente>
          </div>

          <div className="contenedor-derecho-contacto">
            <img 
              src="https://webcontent.cn-grupo.net/Media/Fotos/Contacto/WEB_ IMAGEN 47.png" 
              alt="" 
              className="img-contacto-derecha" 
            />
          </div>
        </div>
      </div>

      <div className="banner-contacto">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Contacto/WEB_ IMAGEN 48.png" 
          alt="Contacto Banner" 
          className="img-banner-contacto"
        />
      </div>

      <div className="footer-container-contacto">
        <div className="footer">
          <div className="footer-left">
            <p className="txt-foo">{t("txt-foo2.Footer1")}</p>
          </div>
          <div className="footer-right">
            <div className="footer-right-left">
              <a 
                href="https://webcontent.cn-grupo.net/Assets/Politica/CN-GRUPO_ Política de privacidad.pdf" 
                target="_blank"
                rel="noopener noreferrer"
                className="txt-foo-politicas"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                Politicas de privacidad
              </a>
            </div>
            <div className="footer-right-right">
              <p className="txt-foo2">{t("txt-foo2.Footer", { year: new Date().getFullYear() })}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacto;







